import { Container, Title, Text, Stack, Anchor } from '@mantine/core';

export function PrivacyPolicy() {
  return (
    <Container size="md" py="xl">
      <Stack>
        <Title order={1}>Termini di Servizio e Informativa sulla Privacy</Title>

        <div>
          <Title order={2}>1. Utilizzo dei Servizi API di YouTube e Google Analytics</Title>
          <Text>
            Il nostro sito web utilizza i Servizi API di YouTube esclusivamente per visualizzare statistiche pubbliche di YouTube, e Google Analytics per monitorare le statistiche di visualizzazione del sito. Non raccogliamo, memorizziamo o elaboriamo alcun dato personale degli utenti. Le informazioni visualizzate sono limitate a dati pubblicamente disponibili.
          </Text>
          <Text>
            Per maggiori informazioni, consulta i <Anchor href="https://www.youtube.com/t/terms" target="_blank" style={{ color: 'blue' }}>Termini di Servizio di YouTube</Anchor> e <Anchor href="https://marketingplatform.google.com/about/analytics/terms/it/" target="_blank" style={{ color: 'blue' }}>Google Analytics</Anchor>.
          </Text>
        </div>

        <div>
          <Title order={2}>2. Termini di Servizio</Title>
          <Text>
            Utilizzando questo sito web, l'utente accetta di essere vincolato dai Termini di Servizio di YouTube. Si consiglia di leggere attentamente i termini di YouTube per comprendere i diritti e le responsabilità dell'utente.
          </Text>
        </div>

        <div>
          <Title order={2}>3. Privacy</Title>

          <Title order={3} mt="md">3.1 Dati Raccolti</Title>
          <Text>
            Il nostro sito web non richiede l'accesso all'account YouTube degli utenti, non richiede login e non raccoglie dati personali. Utilizziamo le API di YouTube solo per recuperare e visualizzare statistiche pubbliche, garantendo la privacy degli utenti.
          </Text>

          <Title order={3} mt="md">3.2 Google Privacy Policy</Title>
          <Text>
            Poiché il nostro servizio utilizza le API di YouTube e Google Analytics, invitiamo gli utenti a consultare la <Anchor href="http://www.google.com/policies/privacy" target="_blank" style={{ color: 'blue' }}>Privacy Policy di Google</Anchor> per comprendere come Google gestisce i dati.
          </Text>

          <Title order={3} mt="md">3.3 Cookie e Tecnologie di Tracciamento</Title>
          <Text>
            Il nostro sito utilizza cookie tecnici essenziali per il funzionamento del sito e Google Analytics esclusivamente per monitorare le statistiche di visualizzazione del sito web. Google Analytics è configurato in modo da raccogliere solo dati aggregati sulle visite al sito, senza tracciare informazioni personali degli utenti. Non utilizziamo cookie di profilazione o altre tecnologie di tracciamento che raccolgono dati personali.
          </Text>

          <Title order={3} mt="md">3.4 Google Analytics</Title>
          <Text>
            Utilizziamo Google Analytics esclusivamente per monitorare le statistiche di visualizzazione aggregate del nostro sito web. Questo strumento raccoglie dati anonimi sulle visite al sito, senza tracciare informazioni personali degli utenti individuali. I dati raccolti includono solo metriche basilari come il numero di visualizzazioni della pagina.
          </Text>
        </div>

        <div>
          <Title order={2}>4. Contatti</Title>
          <Text>
            Per qualsiasi domanda relativa alla privacy o all'utilizzo del sito, gli utenti possono contattarci via email all'indirizzo: <Anchor href="mailto:andreaschisani@gmail.com" style={{ color: 'blue' }}>andreaschisani@gmail.com</Anchor>.
          </Text>
        </div>

        <div>
          <Title order={2}>5. Modifiche alla Privacy Policy</Title>
          <Text>
            Ci riserviamo il diritto di modificare questa informativa sulla privacy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina e gli utenti sono incoraggiati a controllare periodicamente per eventuali aggiornamenti.
          </Text>
        </div>

        <Text className="last-update" mt="xl" style={{ fontStyle: 'italic' }} color="dimmed">
          <strong>Ultimo aggiornamento:</strong> 08/01/2025
        </Text>
      </Stack>
    </Container>
  );
}